import { ADMIN_MENU } from "./adminSidebar";


export const SIDEBAR_MENU = [
    ...ADMIN_MENU
]